import styled from 'styled-components';
import skapaToken from '@ingka/variables';

export const contentDelimiterStyles = `
  max-width: 1024px;
  margin: 0 auto;
  padding: 16px;
`;

export const appHeaderHeight = '108px';

export const appFooterHeight = 'auto';

export const Page = styled.div`
  min-height: calc(100vh - ${appFooterHeight} - ${appHeaderHeight});
  ${contentDelimiterStyles};
`;

export const PageContainer = styled.div`
  background-color: ${skapaToken.colourNeutralGrey100};
`;

export const PageTitle = styled.h2`
  text-align: center;
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const PageFEDSA = styled.div`
  min-height: calc(100vh - ${appFooterHeight} - ${appHeaderHeight});
`;
